const showAlert = () => {
  const alertPopup = document.querySelector('.partners-page__copy-popup');

  if (alertPopup) {
    alertPopup.classList.add('_show');

    setTimeout(() => {
      alertPopup.classList.remove('_show');
    }, 2000);
  }
};

const copyButtonHandler = async (e) => {
  e.preventDefault();

  let target;
  if (e.target.classList.contains('copy-button')) target = e.target;
  else target = e.target.closest('.copy-button');

  const buttonText = target.querySelector('span').innerText;

  const copyTextarea = document.createElement('textarea');
  copyTextarea.style.position = 'fixed';
  copyTextarea.style.opacity = '0';
  copyTextarea.textContent = buttonText;

  document.body.appendChild(copyTextarea);
  copyTextarea.select();
  document.execCommand('copy');
  document.body.removeChild(copyTextarea);

  showAlert();
};

const initCopyButtons = () => {
  const copyButtons = document.querySelectorAll('.copy-button');

  if (copyButtons) {
    copyButtons.forEach((button) => {
      if (button.classList.contains('_init')) return;

      button.addEventListener('click', copyButtonHandler);
      button.classList.add('_init');
    });
  }
};

initCopyButtons();

window.initCopyButtons = initCopyButtons();
